import { Component, OnInit } from '@angular/core';
import { BaseReportActionsDialog } from '../base-report-actions-dialog';
import { GaValidateService } from '../../../formly/ga-validate.service';
import { GaFormlyService } from '../../../formly/ga-formly.service';
import { GaEventService } from '../../../services/ga-event.service';

@Component({
  selector: 'change-sending-status-action',
  templateUrl: '../../../message/dialogs/default-form-dialog.html'
})
export class ChangeSendingStatusActionComponent extends BaseReportActionsDialog implements OnInit {
  constructor(
    private formlyService:GaFormlyService,
    eventService:GaEventService,
    validateService:GaValidateService
  ) {
    super(eventService, validateService);
  }

  public ngOnInit():void {
    super.ngOnInit();

    // create fields
    this.createFields();
  }

  private createFields():void {
    this.fields = [
      this.formlyService.aTextarea('comments', 'Comments').isRequired().build()
    ];
  }
}